import AboutPage from '_components/composed/pages/AboutPage';
import { NextSeo } from 'next-seo';

export default function About() {
  return (
    <>
      <NextSeo
        title="About Incorpified - Simplifying Business Formation for Entrepreneurs"
        description="Learn about Incorpified’s mission to simplify business formation. Discover our dedication to helping entrepreneurs with comprehensive, hassle-free incorporation services."
      />
      <AboutPage />
    </>
  );
}
